import { createSlice } from '@reduxjs/toolkit';
import { PaletteOptions } from '@mui/material';
import { RootState } from '../index';

import {
  setAppThemeModeToLocalStorage,
  getAppThemeModeFromLocalStorage,
  setAdminPortalEditModeValueToLocalStorage,
  getAdminPortalEditModeValueFromLocalStorage,
  checkUserPermission,
  getAuthUserFromLocalStorage,
  isFromIGCSEBuddy,
} from '../../helper';
import { USER_PERMISSION } from '../V2/RolesSlice';

export type TTheme = PaletteOptions['mode'];

export interface IConfigState {
  themeMode: TTheme;
  status: 'idle' | 'loading';
  adminEditMode: boolean;
  tutorHomeworkMode: boolean;
  fromIGCSEBuddy: boolean;
}

// THIS FUNCTION IS FOR THE GROUP CLASSES. IMPROVE THIS LATER FOR OTHER MODULES
const getAdminEditMode = () => {
  let res = false;
  const editMode =
    getAdminPortalEditModeValueFromLocalStorage() === 'true' || false;
  const authUser = getAuthUserFromLocalStorage();
  if (editMode && authUser) {
    res = checkUserPermission(authUser, {
      adminCourse: USER_PERMISSION.ADMIN_COURSE,
    });
  }
  return res;
};

const initialState: IConfigState = {
  themeMode: getAppThemeModeFromLocalStorage(),
  status: 'idle',
  adminEditMode: getAdminEditMode(),
  tutorHomeworkMode: false,
  fromIGCSEBuddy: isFromIGCSEBuddy(),
};

export const ConfigSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      const newTheme: TTheme = state.themeMode === 'light' ? 'dark' : 'light';
      state.themeMode = newTheme;
      setAppThemeModeToLocalStorage(newTheme);
    },
    toggleAdminEditModel: (state) => {
      const value = !state.adminEditMode;

      state.adminEditMode = !state.adminEditMode;

      setAdminPortalEditModeValueToLocalStorage(value ? 'true' : 'false');
    },
    toggleHomeworkModel: (state) => {
      state.tutorHomeworkMode = !state.tutorHomeworkMode;
    },
  },
});

export const {
  toggleTheme,
  toggleAdminEditModel,
  toggleHomeworkModel,
} = ConfigSlice.actions;

export const getThemeMode = (state: RootState): TTheme =>
  state.config.themeMode;

export const getConfigState = (state: RootState): RootState['config'] =>
  state.config;

export default ConfigSlice.reducer;
